import { MutableRefObject } from "react";
import Youtube, { isValidYoutubeUrl } from "@tiptap/extension-youtube";
import { Plugin } from "@tiptap/pm/state";

export type OnYoutubePaste = (params: {
  anchorRect: DOMRect;
  url: string;
  from: number;
  to: number;
}) => void;

export const createYoutubeExtension = (
  onYoutubePasteRef: MutableRefObject<OnYoutubePaste>,
) =>
  Youtube.extend({
    addProseMirrorPlugins() {
      return [
        new Plugin({
          props: {
            handlePaste: (view, event) => {
              const text =
                event.clipboardData?.getData("text/plain")?.trim() ?? "";
              if (!isValidYoutubeUrl(text)) return false;
              const { from, to: selTo } = view.state.selection;
              const to = from + text.length;
              const coords = view.coordsAtPos(from);
              const tr = view.state.tr.insertText(text, from, selTo);
              const linkMark = view.state.schema.marks.link;
              if (linkMark) {
                tr.addMark(from, to, linkMark.create({ href: text }));
              }
              view.dispatch(tr);
              onYoutubePasteRef.current({
                anchorRect: new DOMRect(coords.left, coords.bottom, 0, 0),
                url: text,
                from,
                to,
              });
              return true;
            },
          },
        }),
      ];
    },
  }).configure({
    width: 560,
    // Without an explicit title, the rendered <iframe> has no accessible name
    // (axe-core: frame-title). The embed URL alone doesn't tell us the video's
    // real title, so use a generic-but-meaningful description.
    HTMLAttributes: { title: "Embedded YouTube video" },
  });
